import React, { Fragment, useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  CardImg,
  ButtonGroup,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
  postAPI_Compendium_ResetPassword,
  API_Ingetration_Channels,
  aPI_Contacts,
} from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import ContactDetails from './contactDetails';
import moment from 'moment';
import { connect } from 'react-redux';
import ContactForm from './contactForm';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { fetchServiceRequest } from '../../../../../redux/service/actions';
import ImageGallery from '../../propinfo/gallery/index';
import IntlMessages from '../../../../../helpers/IntlMessages';

function ContactInfo({
  propertyId,
  chatListApp,
  match,
  item,
  serviceProvider,
  featuresUrl,
  fetchServiceRequest,
}) {
  const contactId = match.params.id;
  const [editContact, setEditContact] = useState(false);
  const [note, setNote] = useState('');
  const [contact, setContact] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedChat, setSelectedChat] = useState();
  const [integrations, setIntegrations] = useState([]);
  const [updateModal, setUpdateModal] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [passwordDetails, setPasswordDetails] = useState({
    password: '',
    confirmPassword: '',
  });
  useEffect(() => {
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider]);
  useEffect(
    (propertyId) => {
      const callApi = async () => {
        if (contactId !== undefined && contactId !== '') {
          await handleContactLoad();
        }
        await LoadIntegrations();
      };
      callApi();
    },
    [propertyId]
  );
  useEffect(
    (props) => {
      if (selectedChat?.conversationId) {
        if (
          selectedChat?.conversationId !==
          chatListApp?.selectedchat?.conversationId
        ) {
          setSelectedChat(chatListApp?.selectedchat);
        }
      } else setSelectedChat(chatListApp?.selectedchat);
    },
    [chatListApp]
  );
  const toggleModal = () => {
    setUpdateModal(false);
    setPasswordDetails({
      password: '',
      confirmPassword: '',
    });
  };

  const handleUpdatePassword = () => {
    if (passwordDetails.password !== '') {
      if (passwordDetails.password === passwordDetails.confirmPassword) {
        let data = {
          username: contact?.email,
          propertyId: propertyId,
          groupId: getGroupID(),
          password: passwordDetails.password,
          creator: 'Admin',
        };
        AxiosAPI({
          method: 'put',
          url: `${postAPI_Compendium_ResetPassword}`,
          data: data,
        }).then((res) => {
          NotificationManager.success(
            '',
            'Password updated sucessfully.',
            3000,
            null,
            null,
            'error'
          );
          toggleModal();
        });
      } else {
        NotificationManager.error(
          '',
          'Password and current password both are not matched',
          3000,
          null,
          null,
          'error'
        );
      }
    } else {
      NotificationManager.error(
        '',
        'Password can`t be empty.',
        3000,
        null,
        null,
        'error'
      );
    }
  };

  const handleContactLoad = async () => {
    const contactResponse = await AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts}/${contactId}`,
    });
    if (contactResponse.data !== undefined && contactResponse.data?.contactId) {
      setContact(contactResponse.data);
    }
  };

  const handlePassword = (e) =>
    setPasswordDetails({ ...passwordDetails, [e.target.name]: e.target.value });

  const LoadIntegrations = async () => {
    setIsLoading(true);
    let body = {
      channels: [
        'WebsiteDirectLine',
        'FacebookDirectLine',
        'WhatsApp',
        'EmailDirectLine',
        'PhoneSuite',
        'Instagram',
        'TeamsApp',
      ],
    };
    const response = await AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    });
    if (response.data.length > 0) {
      const webIntegrationData = response.data.filter(
        (k) =>
          (k.channel === 'WebsiteDirectLine' ||
            k.channel === 'FacebookDirectLine' ||
            k.channel === 'WhatsApp' ||
            k.channel === 'EmailDirectLine' ||
            k.channel === 'PhoneSuite' ||
            k.channel === 'Instagram' ||
            k.channel === 'TeamsApp') &&
          k.properties.filter((f) => f === propertyId).length > 0
      );
      setIntegrations(webIntegrationData);
    } else {
    }
  };

  const selectedImage = (image) => {
    // setpropertyData({
    //   ...propertyData,
    //   images: image.src,
    // });
  };

  const toggle = () => setEditContact(!editContact);

  const handleEdit = (body) => {
    AxiosAPI({
      method: 'put',
      url: `${aPI_Contacts}/${contactId}`,
      data: body,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((res) => {
      toggle();
      handleContactLoad();
    });
  };

  const handleSaveNotes = () => {
    if (note !== '') {
      AxiosAPI({
        method: 'put',
        url: `${aPI_Contacts}/notes/${contactId}`,
        data: { note: note },
      }).then((res) => {
        setNote();
        handleContactLoad();
      });
    }
  };

  return (
    <Fragment>
      {contact !== undefined && (
        <Row style={{ marginLeft: '-3%', marginRight: '-2%' }}>
          <Colxx xxs="12" md="3" className="mb-2 col-sm-12 col-md-3 pr-0">
            <Card
              className="d-flex flex-row mb-2"
              style={{ borderRadius: '10px', maxWidth: '100%' }}
            >
              <CardBody>
                <div className="mb-3">
                  <Colxx md="12" className="mb-2">
                    <div class="user-info">
                      <div className="d-flex justify-content-center">
                        {contact?.channel === 'Compendium' &&
                          contact?.profile !== '' ? (
                          <div className="">
                            <img
                              src={`data:jpeg;base64,${contact?.profile}`}
                              style={{ borderRadius: '50%', width: '100px' }}
                            ></img>
                            <span
                              className="contact-details-edit"
                              style={{ right: '30%' }}
                              onClick={toggle}
                            >
                              <i className="simple-icon-pencil"></i>
                            </span>
                          </div>
                        ) : (
                          <div className="contact-round-name">
                            <span>
                              <b>
                                {contact?.name ? (
                                  <Fragment>
                                    {contact.name.split(' ').length > 1
                                      ? contact.name.split(' ')[0][0] +
                                      contact.name.split(' ')[1][0]
                                      : contact.name[0] + contact.name[1]}
                                  </Fragment>
                                ) : (
                                  'UK'
                                )}
                              </b>
                            </span>
                            <span
                              className="contact-details-edit"
                              onClick={toggle}
                            >
                              <i className="simple-icon-pencil"></i>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </Colxx>
                  <div className="d-flex justify-content-center mb-2">
                    <h4>{contact?.name !== '' ? contact?.name : 'Unknown'}</h4>
                  </div>
                  <Colxx md="12" className="p-0">
                    <Card className="mb-2 p-3" style={{ borderRadius: '20px' }}>
                      <div className="d-flex mb-2">
                        <p
                          className="mb-0 mr-0"
                          style={{ wordBreak: 'break-all' }}
                        >
                          <i
                            className={`simple-icon-phone`}
                            style={{
                              marginLeft: '0.2em',
                              marginRight: '0.2em',
                            }}
                          ></i>{' '}
                          Phone{'   '}
                          <b>{contact?.phone}</b>
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-at-sign`}></i> Email{'   '}
                          <b>{contact?.email}</b>
                        </p>
                      </div>
                      {/* <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`simple-icon-calendar`}></i> Signed Up{' '}
                          {'   '} <b>{contact?.signUp}</b>
                        </p>
                      </div> */}
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-calendar-4`}></i> First
                          Activity{'   '} <b>{contact?.firstActivity}</b>
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-calendar-4`}></i> Last
                          Activity{'   '}
                          <b>{contact?.lastActivity}</b>
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i
                            className={`simple-icon-settings`}
                            style={{
                              marginLeft: '0.2em',
                              marginRight: '0.2em',
                            }}
                          ></i>{' '}
                          Last Channel{'   '}
                          <b>{contact?.lastChannel}</b>
                        </p>
                      </div>
                      {contact?.consent && (
                        <div className="d-flex mb-2">
                          <p className="mb-0 mr-0">
                            <i className="iconsminds-yes"></i>{' '}
                            <IntlMessages id="dashboards.marketingconsent" />
                            {'   '}
                            {contact.consent === 'Yes' ? (
                              <b
                                style={{
                                  color: 'green',
                                }}
                              >
                                {contact.consent}
                              </b>
                            ) : (
                              <b style={{ color: 'red' }}>{contact.consent}</b>
                            )}{' '}
                          </p>
                        </div>
                      )}
                      {selectedChat?.visitor && (
                        <Fragment>
                          {selectedChat?.visitor?.location && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className={`iconsminds-location-2`}></i>{' '}
                                Location{'   '}
                                <b>{selectedChat?.visitor.location}</b>
                              </p>
                            </div>
                          )}
                          {selectedChat?.visitor?.deviceType && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className="iconsminds-computer"></i> Device
                                {'   '}
                                <b>{selectedChat?.visitor.deviceType}</b>
                              </p>
                            </div>
                          )}
                          {selectedChat?.visitor?.browser && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className="iconsminds-optimization"></i>{' '}
                                Browser{'   '}
                                <b>{selectedChat?.visitor.browser}</b>
                              </p>
                            </div>
                          )}
                        </Fragment>
                      )}
                      {contact.additionalInfo !== undefined &&
                        contact.additionalInfo !== null && (
                          <Fragment>
                            {contact?.additionalInfo?.groupName && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i
                                    className={`iconsminds-business-man-woman`}
                                  ></i>{' '}
                                  Group Name{'   '}
                                  <b>{contact?.additionalInfo.groupName}</b>
                                </p>
                              </div>
                            )}
                            {contact?.additionalInfo?.businessName && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i
                                    className={`iconsminds-chrysler-building`}
                                  ></i>{' '}
                                  Business Name{'   '}
                                  <b>{contact?.additionalInfo.businessName}</b>
                                </p>
                              </div>
                            )}
                            {contact?.additionalInfo?.propertyName && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i className={`iconsminds-building`}></i>{' '}
                                  Property Name{'   '}
                                  <b>{contact?.additionalInfo.propertyName}</b>
                                </p>
                              </div>
                            )}
                            {contact?.additionalInfo?.chainName && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i className={`iconsminds-solar`}></i> Chain
                                  Name{'   '}
                                  <b>{contact?.additionalInfo.chainName}</b>
                                </p>
                              </div>
                            )}
                            {contact?.additionalInfo?.userType && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i className={`iconsminds-user`}></i> User
                                  Type{'   '}
                                  <b>{contact?.additionalInfo.userType}</b>
                                </p>
                              </div>
                            )}
                          </Fragment>
                        )}
                      {contact?.channel === 'Compendium' && (
                        <Colxx md="12" className="p-0 my-2">
                          <Button
                            color="primary"
                            className="mr-3"
                            outline
                            size="xs"
                            onClick={() => setUpdateModal(true)}
                          >
                            Reset Password
                          </Button>
                        </Colxx>
                      )}
                    </Card>
                  </Colxx>
                </div>

                {/* </Card> */}
                <Colxx md="12" className="p-0">
                  <Card className="mb-2 p-3" style={{ borderRadius: '20px' }}>
                    <div className="mb-3">
                      <Input
                        type="textarea"
                        onChange={(e) => setNote(e.target.value)}
                        style={{ height: '50px' }}
                        placeholder="Add Note"
                      ></Input>
                    </div>
                    {note !== '' && (
                      <Fragment>
                        <div className="d-flex">
                          <div className="col-md-6 mb-2">
                            <Button
                              color="secondary"
                              className="mr-3"

                              size="xs"
                              style={{ width: '100%' }}
                              onClick={() => setNote('')}
                            >
                              Cancel
                            </Button>
                          </div>
                          <div className="col-md-6 mb-2 ml-2">
                            <Button
                              color="primary"

                              size="xs"
                              style={{ width: '100%' }}
                              onClick={handleSaveNotes}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </Fragment>
                    )}
                    <div className="mb-2">
                      <div className="contact-notes-body">
                        <ul className="list-group">
                          {contact?.notes &&
                            contact.notes.length > 0 &&
                            contact.notes.map((m) => (
                              <div className="mt-2 mb-2  details-subheading">
                                <b className="mb-2 d-flex">
                                  {moment(m.date).format(
                                    'MMMM Do YYYY, h:mm:ss a'
                                  )}
                                </b>
                                <p
                                  className="mb-2 d-flex"
                                  style={{ color: 'black' }}
                                >
                                  {m.text}
                                </p>
                              </div>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </Card>
                </Colxx>
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xxs="12" md="9" className="mb-2 col-sm-12 col-md-9 pr-0">
            {integrations.length > 0 ? (
              <ContactDetails
                contactId={contactId}
                contact={contact}
                integrationData={integrations.length > 0 ? integrations : []}
                featuresUrl={featuresUrl}
              ></ContactDetails>
            ) : null}
          </Colxx>
        </Row>
      )}
      <Modal isOpen={updateModal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Reset Password</ModalHeader>
        <ModalBody>
          {' '}
          <Form className="text-left">
            <FormGroup className="mb-2">
              <Label>Password</Label>
              <Input
                type="password"
                name="password"
                onChange={handlePassword}
                value={passwordDetails?.password}
                placeholder="Password"
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <Label>Confirm Password</Label>
              <Input
                type="password"
                name="confirmPassword"
                onChange={handlePassword}
                value={passwordDetails?.confirmPassword}
                placeholder="Confirm Password"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleUpdatePassword()}>
            Save
          </Button>
          <Button className="ml-2" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      {editContact === true && (
        <ContactForm
          toggle={toggle}
          visible={editContact}
          item={contact}
          propertyId={propertyId}
          handleSubmit={handleEdit}
        ></ContactForm>
      )}
    </Fragment>
  );
}
const mapStateToProps = ({ chatListApp, settings, service }) => {
  const { propertyId, timeZone, locale, email, serviceProvider } = settings;
  const { featuresUrl } = service;
  return {
    chatListApp,
    propertyId,
    timeZone,
    locale,
    email,
    serviceProvider,
    featuresUrl,
  };
};
export default connect(mapStateToProps, { fetchServiceRequest })(ContactInfo);
